import React from 'react';
import ModalDefault from 'v2/components/ModalDefault';
import { IModalMostUsedCommand } from './types';

import * as SC from './styles';
import Icon from 'v2/components/Icon';
import useModalMostUsedCommand from './hooks/useModalMostUsedCommand';
const ModalMostUsedCommand: React.FC<IModalMostUsedCommand> = ({
  isOpen,
  onBack,
  onClose,
  setPrompt,
}) => {
  const { options, handelSetPrompt } = useModalMostUsedCommand({
    setPrompt,
    onClose,
  });
  return (
    <ModalDefault
      title="COMANDOS MAIS USADOS"
      iconName="AutoModeOutlined"
      isOpen={isOpen}
      onBack={onBack}
      onClose={onClose}
    >
      <SC.Container>
        <SC.Content>
          {options.map((item) => (
            <SC.Option
              key={item.id}
              onClick={() => handelSetPrompt(item.title)}
            >
              {item.title}
              <Icon
                htmlColor="#fff"
                fontSize="small"
                iconName="ArrowForwardIosOutlined"
              />
            </SC.Option>
          ))}
        </SC.Content>
      </SC.Container>
    </ModalDefault>
  );
};

export default ModalMostUsedCommand;
